import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';
import { CancelToken, AxiosRequestConfig } from 'axios';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, DeviceResponseModel } from './models'

export const addAndroidDevice = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/devices`, { ...params });
}

export const updateDeviceUser = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/devices/${id}/users`, { ...params });
}
export const updateDeviceOrg = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/devices/${id}/orgs`, { ...params });
}
export const getDevices = (params: ListRuquestModel, TagValueIds: string[], extras: any = ""): Promise<DeviceResponseModel<any>> => {
  var tags = "";
  TagValueIds?.forEach((tag: string, index: number) => {
    if (index != 0) {
      tags += "&"
    }
    tags = tags + "TagValueIds=" + tag
  });
  if (extras) {
    let tmp: any[] = []
    Object.keys(extras).forEach(key => {
      if (extras[key]?.length > 0) {
        tmp.push(extras[key].map((value: any) => `${key}=${value}`).join("&"));
      }
    })
    extras = tmp.length > 0 ? tmp.join("&") : "";
  } else {
    extras = "";
  }
  return AxiosInstance.get(`${API_URL}/devices?` + tags + extras, { params });
}

export const getDeviceFilter = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/filters`, { params });
}

export const getDeviceCounts = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/counts`);
}

export const deleteDevice = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/devices/${id}`);
}

export const getAllDevices = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/devices/list`, { params });
}

export const getDeviceInfo = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}`);
}
export const getDeviceBypassCode = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/byapasscode`);
}

export const disown = (id: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/abm/devices/${id}/disown`);
}

export const getDeviceApps = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/apps`, { params });
}

export const getDeviceCertificate = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/certificates`, { params });
}

export const getDeviceAppList = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/applist`);
}

export const getMacDeviceApps = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/mac/devices/${id}/apps`, { params });
}

export const getMacDeviceAppList = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/devices/${id}/applist`);
}

export const getMacDeviceManagedApps = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/mac/devices/${id}/managedApps`, { params });
}

export const getMacDeviceManagedAppList = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/devices/${id}/managedApplist`);
}

export const deleteAndroidDevice = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/devices/${id}`);
}

export const getDeviceLocations = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/locations`);
}
export const getDeviceOperations = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/operations`, { params });
}
export const getDeviceSensitiveOperations = (id: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/devices/${id}/sensitive/operations`, { params });
}
export const getAndroidQrcode = (platform: string, pixel: number): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/qrcode`, { params: { platform, pixel } });
}

export const androidDeviceOperation = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/devices/${id}/operations`, { ...params });
}

export const iosDeviceOperation = (id: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/ioscommand/${id}`, { ...params });
}
export const iosDeviceDisenroll = (id: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/ioscommand/${id}/disenroll`, { ...params });
}
export const macOSDeviceOperation = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/devices/${id}/operations`, { ...params });
}
export const macDeviceOperation = (id: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/mac/devices/${id}/operations`, { ...params });
}

export const bypassActivationlock = (deviceId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/apns/devices/${deviceId}/bypasscode`);
}
export const installEnterprise = (deviceId: string, appId: string): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/${deviceId}/enterprise/app/${appId}`);
}


export const getTemplateList = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates`, { params });
}
export const getTemplateTabs = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/template/tabs`);
}

export const getTemplateListAll = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/list`);
}

export const getTemplate = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${id}`);
}

export const deleteTemplate = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${id}`);
}

export const addTemplate = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates`, { ...params });
}

export const addDeviceForTemplate = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/templates/${templateId}/devices`, { ...params });
}
export const getDeviceForTemplate = (templateId: string, params: any, TagValueIds: string[]): Promise<ListResponseModel<any>> => {
  var tags = "";
  TagValueIds?.forEach((tag: string, index: number) => {
    if (index != 0) {
      tags += "&"
    }
    tags = tags + "tagValueIds=" + tag
  });
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/devices?` + tags, { params });
}
export const getUnSelectedDevices = (templateId: string, params: any): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/devices/unselected`, { params });
}
export const deleteDeviceForTemplate = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/devices`, { params });
}
export const updateDeviceTemplate = (templateId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/devices/${templateId}/templates`, { ...params });
}
export const applyAndroidTemplate = (templateId: string, deviceId: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/devices/${deviceId}/templates/${templateId}/apply`);
}
export const applyTemplate = (templateId: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/templates/${templateId}/apply`);
}

// export const updateIosDeviceTemplate = (deviceId:string,templateId:string): Promise<string[]> => {
//   return AxiosInstance.put(`${API_URL}/apns/${deviceId}/template/${templateId}`);
// }

export const getWebclips = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/${templateId}/webclips`, { params });
}
export const addWebclip = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(`${API_URL}/ios/settings/${templateId}/webclip`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export const deleteAllWebclips = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/webclips`);
}

export const deleteWebclips = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/webclip/${id}`);
}

export const getAndroidWebclips = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/webclips`);
}
export const addAndroidWebclip = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/webclips`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export const deleteAndroidAllWebclips = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/webclips`);
}

export const deleteAndroidWebclips = (templateId: string, id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/webclips/${id}`);
}

export const addTemplatePassword = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/ios/passwords`, { ...params });
}
export const deleteTemplatePassword = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/ios/password`);
}

export const getTemplatePassword = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/ios/password`);
}
export const deleteAndroidTemplatePassword = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/password`);
}
export const addAndroidTemplatePassword = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/passwords`, { ...params });
}

export const getAndroidTemplatePassword = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/password`);
}

export const deleteTemplateAllApp = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/apps/delete`);
}
export const deleteTemplateApp = (templateId: string, appId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/app/${appId}/delete`);
}
export const getTemplateApp = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/apps`);
}

export const addTemplateApp = (templateId: string, params: any[]): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/apps/add`, params);
}

export const deleteAndroidTemplateAllApp = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/apps`);
}
export const deleteAndroidTemplateApp = (templateId: string, appId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/apps/${appId}`);
}
export const getAndroidTemplateApp = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/apps`);
}

export const addAndroidTemplateApp = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/apps`, params);
}


export const commandRetry = (commandId: string): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/${commandId}/retry`);
}


export const deleteAndroidTemplateSingleapp = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/singleapp`);
}
export const addAndroidTemplateSingleapp = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/singleapps`, { ...params });
}

export const getAndroidTemplateSingleapp = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/singleapp`);
}

export const deleteTemplateSingleapp = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/multiappmode`);
}
export const addTemplateSingleapp = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/${templateId}/multiappmode`, { ...params });
}

export const getTemplateSingleapp = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/${templateId}/multiappmode`);
}


export const deleteTemplateLock = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/lock`);
}
export const addTemplateLock = (templateId: string, _params: any[]): Promise<any> => {
  const params = new FormData();
  _params.forEach(key => {
    params.append(key.key, key.value);
  });
  console.log(params)
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/locks`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}

export const getTemplateLock = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/lock`);
}
export const getTemplateLockOptions = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/lockscreen/msgkeys`);
}

export const deleteTemplateWallpaper = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/wallpaper/delete`);
}
export const addTemplateWallpaper = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/wallpaper`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export const getTemplateWallpaper = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/wallpaper`);
}

export const deleteAndroidTemplateWallpaper = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/wallpaper`);
}
export const addAndroidTemplateWallpaper = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/wallpapers`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export const getAndroidTemplateWallpaper = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/wallpaper`);
}

export const addTemplateNetwork = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/networks`, { ...params });
}
export const deleteTemplateNetwork = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/networks`);
}
export const deleteNetwork = (templateId: string, networkId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/networks/${networkId}`);
}

export const getTemplateNetwork = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/network`);
}
export const getTemplateNetworks = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/networks`, { params });
}

export const getDocuments = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/documnets/medias`, { params });
}

export const getTemplateBook = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/medias`, { params });
}

export const addTemplateBook = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/medias`, { ...params });
}

export const deleteTemplateBook = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/medias`);
}

export const deleteBook = (templateId: string, mediaId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/medias/${mediaId}`);
}

export const addTemplateRestriction = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/restrictions`, { ...params });
}
export const deleteTemplateRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/restriction`);
}

export const getTemplateRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/restriction`);
}
export const modifyDeviceName = (deviceId: string, name: string): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/${deviceId}/${name}`);
}

export const getAppRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/${templateId}/app/restriction`);
}
export const deleteAppRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/app/restriction`);
}
export const deleteAppRestrictionAlone = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/app/restriction/${id}`);
}

export const addAppRestriction = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/${templateId}/app/restriction`, params);
}

export const getAndroidAppRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/app/restriction`);
}
export const deleteAndroidAppRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/app/restriction`);
}
export const deleteAndroidAppRestrictionAlone = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/app/restriction/${id}`);
}

export const addAndroidAppRestriction = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/app/restriction`, params);
}

export const getWebfilter = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/${templateId}/webfilter`);
}

export const addWebfilter = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/${templateId}/webfilter`, { ...params });
}

export const deleteWebfilter = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/webfilter`);
}
export const getAndroidWebfilter = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/webfilter`);
}

export const addAndroidWebfilter = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/webfilter`, { ...params });
}

export const deleteAndroidWebfilter = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/webfilter`);
}
export const getAllowapps = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/allowapps`);
}

export const addAndroidTemplateRestriction = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/android/restrictions`, { ...params });
}
export const deleteAndroidTemplateRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/android/restriction`);
}
export const getAndroidTemplateRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/android/restriction`);
}

export const getHomescreen = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/${templateId}/homescreen`);
}

export const addHomescreen = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/${templateId}/homescreen`, { ...params });
}
export const deleteHomescreen = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/homescreen`);
}
export const getHomescreenV2 = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/${templateId}/homescreenLayout`);
}

export const addHomescreenV2 = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/${templateId}/homescreenLayout`, { ...params });
}
export const deleteHomescreenV2 = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/${templateId}/homescreenLayout`);
}

export const getAllApps = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/apps/all`);
}
export const getAllWebClips = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/webclips`);
  // return AxiosInstance.get(`${API_URL}/ios/settings/webclips`);
}
export const deleteTemplateCertificate = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/certificate/${id}`);
}
export const deleteTemplateAllCertificate = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}certificates`);
}
export const addTemplateCertificate = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/certificate`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
export const getTemplateCertificate = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/certificates`);
}

export const addTemplateCertificateWithCert = (templateId: string, certId: string): Promise<any> => {

  return AxiosInstance.put(`${API_URL}/templates/${templateId}/certificate/${certId}`);
}

export const getTemplateCustomConfig = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/customconfig`);
}

export const deleteTemplateCustomConfig = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/customconfig`);
}

export const addTemplateCustomConfig = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key])
  }
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/customconfig`, params);
}

export const setDeviceRemarks = (deviceId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/devices/${deviceId}/remarks`, params)
}

export const iosDeviceOperations = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/ioscommands`, { ...params });
}

export const androidDeviceOperations = (params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/devices/operations`, { ...params });
}

export const appDeviceTemplate = (templateId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/devices/templates/${templateId}/apply`, { ...params });
}

export const batchEditDevices = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key])
  }
  return AxiosInstance.post(`${API_URL}/devices/import`, params);
}

export const exportDevices = (params: any, tagIds: string[]): Promise<any> => {
  var tags = "";
  tagIds?.forEach((tag: string, index: number) => {
    if (index !== 0) {
      tags += "&";
    }
    tags = tags + "TagValueIds=" + tag;
  });
  var requestConfig: AxiosRequestConfig = {
    responseType: "blob",
    params: params
  };
  return AxiosInstance.get(`${API_URL}/devices/export?` + tags, requestConfig);
}

export const getClassRoomScopes = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/classrooms/${roomId}/scopes`, {params});
}

export const authClassRoomScopes = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/classrooms/${roomId}/scopes`, { ...params });
}

export const resetClassRoomScopes = (roomId: string, params: any): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/classrooms/${roomId}/scopes`, {params});
}

export const classRoomExcludes = (roomId: string, deviceId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/ios/settings/classrooms/${roomId}/devices/${deviceId}/excludes`, params);
}

export const classRoomAllDeviceExcludes = (roomId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/ios/settings/classrooms/${roomId}/excludes`, params);
}

export const getTemplateScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/scopes`);
}

export const resetTemplateScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/templates/${templateId}/scopes`);
}

export const authTemplateScopes = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/${templateId}/scopes`, { ...params });
}

export const getDeviceProfiles = (deviceId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${deviceId}/profiles`, { params });
}

export const getDeviceProfiles2 = (deviceId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${deviceId}/templates/state`, { params });
}

export const getDeviceContents = (deviceId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${deviceId}/contents`, { params });
}

export const getDeviceRestrictions = (deviceId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/devices/${deviceId}/restrictions`, { params });
}

export const opDeviceRestrictions = (deviceId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/devices/${deviceId}/restrictions`, params);
}

export const copyTemplates = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/templates/copy`, { ...params });
}

export const updateDevicesShowColumns = (account: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/account/${account}/devicecolumns`, { ...params });
}
export const updateDevicesOrders = (account: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/account/${account}/deviceorders`, { ...params });
}

export const deviceClearCommand = (deviceId: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/devices/${deviceId}/clearcommand`);
}

export const templateResend = (templateId: string, deviceId: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/templates/${templateId}/devices/${deviceId}/resend`);
}

export const getTemplateADDomain = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/addomains`);
}

export const deleteTemplateADDomain = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/addomains`);
}

export const putTemplateADDomain = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/addomains`, { ...params });
}

export const getTemplateHttpProxy = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/httpproxys`);
}

export const deleteTemplateHttpProxy = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/httpproxys`);
}

export const putTemplateHttpProxy = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/httpproxys`, { ...params });
}

export const getTemplateDNSSetting = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/dnssettings`);
}

export const deleteTemplateDNSSetting = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/dnssettings`);
}

export const putTemplateDNSSetting = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/dnssettings`, { ...params });
}

export const templateExcludes = (templateId: string, deviceId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/templates/${templateId}/devices/${deviceId}/excludes`, params);
}

export const templateAllDeviceExcludes = (templateId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/templates/${templateId}/excludes`, params);
}

export const deviceExcludes = (deviceId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/devices/${deviceId}/excludes`, params);
}

export const openLock = (serialNumber: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/apns/devices/${serialNumber}/activationlock`);
}

export const getTemplateADCertificate = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/adcertificate`);
}

export const deleteTemplateADCertificate = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/adcertificate`);
}

export const putTemplateADCertificate = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/adcertificate`, { ...params });
}

export const getTemplateSystemExtension = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/systemextension`);
}

export const putTemplateSystemExtension = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/systemextension`, { ...params });
}

export const putAllowManuallySystemExtension = (templateId: string, isAllow: boolean): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/allowmanually?isAllow=${isAllow}`);
}

export const deleteSystemExtensionList = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/systemextension`);
}

export const deleteSystemExtension = (templateId: string, systemExtensionId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/systemextension/${systemExtensionId}`);
}

export const getTemplateKernelExtension = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/kernelextension`);
}

export const putTemplateKernelExtension = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/kernelextension`, { ...params });
}

export const batchUpdateKernelExtension = (templateId: string, isAllow: boolean, allowNonAdmin: boolean): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/batchUpdateKernelExtension?isAllow=${isAllow}&&allowNonAdmin=${allowNonAdmin}`);
}

export const deleteKernelExtensionList = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/kernelextension`);
}

export const deleteKernelExtension = (templateId: string, kernelExtensionId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/kernelextension/${kernelExtensionId}`);
}

export const getTemplateRecoveryLock = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/recoverylocks`);
}

export const deleteTemplateRecoveryLock = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/recoverylocks`);
}

export const putTemplateRecoveryLock = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/recoverylocks`, { ...params });
}

export const getTemplatePrivacyPreferences = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/PrivacyPreferences`, { params });
}

export const putTemplatePrivacyPreferences = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/PrivacyPreferences`, { ...params });
}

export const deleteTemplatePrivacyPreferences = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/PrivacyPreferences`);
}

export const deleteTemplatePrivacyPreferenceById = (templateId: string, id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/PrivacyPreferences/${id}`);
}

export const getPendingCommands = (deviceId: string, params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/devices/${deviceId}/pendingcommands`, { params });
}

export const deletePendingCommand = (deviceId: string, commandId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/devices/${deviceId}/pendingcommands/${commandId}`);
}

export const getTemplateAppInstallStateList = (templateId: string, params: any,): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/apps/installstates`, { params });
}

export const templateAppRetryInstall = (templateId: string, packageName: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/templates/${templateId}/apps/${packageName}/retryinstall`);
}

export const getTemplateAppInstallDetailList = (templateId: string, packageName: string, params: any,): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/templates/${templateId}/apps/${packageName}/installdetails`, { params });
}

export const getTemplateDeviceMode = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/devicemode`);
}

export const deleteTemplateDeviceMode = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/devicemode`);
}

export const putTemplateDeviceMode = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/devicemode`, { ...params });
}

export const getTemplateLdap = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/ldaps`);
}

export const deleteTemplateLdap = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/ldaps`);
}

export const putTemplateLdap = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/ldaps`, { ...params });
}


export const getTemplateLoginItems = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/loginitems`);
}

export const putTemplateLoginItems = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/loginitems`, { ...params });
}

export const deleteLoginItems = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/loginitems`);
}

export const deleteLoginItem = (templateId: string, itemId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/loginitems/${itemId}`);
}

export const deleteMacTemplateAppRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/settings/${templateId}/mac/apprestrictions`);
}

export const addMacTemplateAppRestriction = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/settings/${templateId}/mac/apprestrictions`, { ...params });
}

export const getMacTemplateAppRestriction = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/settings/${templateId}/mac/apprestrictions`);
}

export const deleteMacTemplateCustomScript = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/mac/customscripts`);
}

export const addMacTemplateCustomScript = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key])
  }
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/mac/customscripts`, params);
}

export const getMacTemplateCustomScript = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/mac/customscripts`);
}


export const getMacTemplateList = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/templates`, { params });
}

export const getMacTemplate = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/templates/${id}`);
}

export const deleteMacTemplate = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/templates/${id}`);
}

export const addMacTemplate = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/templates`, { ...params });
}

export const addDeviceForMacTemplate = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/mac/templates/${templateId}/devices`, { ...params });
}
export const getDeviceForMacTemplate = (templateId: string, params: any, TagValueIds: string[]): Promise<ListResponseModel<any>> => {
  var tags = "";
  TagValueIds?.forEach((tag: string, index: number) => {
    if (index != 0) {
      tags += "&"
    }
    tags = tags + "tagValueIds=" + tag
  });
  return AxiosInstance.get(`${API_URL}/mac/templates/${templateId}/devices?` + tags, { params });
}
export const getUnSelectedMacDevices = (templateId: string, params: any): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/mac/templates/${templateId}/devices/unselected`, { params });
}
export const deleteDeviceForMacTemplate = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/templates/${templateId}/devices`, { params });
}

export const applyMacTemplate = (templateId: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/mac/templates/${templateId}/apply`);
}

export const copyMacTemplates = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/templates/copy`, { ...params });
}

export const macTemplateExcludes = (templateId: string, deviceId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/mac/templates/${templateId}/devices/${deviceId}/excludes`, params);
}

export const macTemplateAllDeviceExcludes = (templateId: string, params: any): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/mac/templates/${templateId}/excludes`, params);
}

export const macTemplateResend = (templateId: string, deviceId: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/mac/templates/${templateId}/devices/${deviceId}/resend`);
}

export const getMacTemplateScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/templates/${templateId}/scopes`);
}

export const resetMacTemplateScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/templates/${templateId}/scopes`);
}

export const authMacTemplateScopes = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/templates/${templateId}/scopes`, { ...params });
}



export const getCommandPolicy = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/policies/${id}`);
}

export const deleteCommandPolicy = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/policies/${id}`);
}

export const addCommandPolicy = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/policies`, { ...params });
}

export const getCommandPolicyList = (params: any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/policies`, { params });
}

export const addDeviceForCommandPolicy = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/mac/policies/${templateId}/devices`, { ...params });
}
export const getDeviceForCommandPolicy = (templateId: string, params: any, TagValueIds: string[]): Promise<ListResponseModel<any>> => {
  var tags = "";
  TagValueIds?.forEach((tag: string, index: number) => {
    if (index != 0) {
      tags += "&"
    }
    tags = tags + "tagValueIds=" + tag
  });
  return AxiosInstance.get(`${API_URL}/mac/policies/${templateId}/devices?` + tags, { params });
}
export const getUnSelectedCommandPolicyDevices = (templateId: string, params: any): Promise<any[]> => {
  return AxiosInstance.get(`${API_URL}/mac/policies/${templateId}/devices/unselected`, { params });
}
export const deleteDeviceForCommandPolicy = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/policies/${templateId}/devices`, { params });
}

export const getCommandPolicyScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/mac/policies/${templateId}/scopes`);
}

export const resetCommandPolicyScopes = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/mac/policies/${templateId}/scopes`);
}

export const authCommandPolicyScopes = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/mac/policies/${templateId}/scopes`, { ...params });
}

export const policyResend = (policyId: string, deviceId: string): Promise<string[]> => {
  return AxiosInstance.post(`${API_URL}/mac/policies/${policyId}/devices/${deviceId}/resend`);
}

export const deleteMacTemplateSecurity = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/mac/securities`);
}

export const addMacTemplateSecurity = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/mac/securities`, params);
}

export const getMacTemplateSecurity = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/mac/securities`);
}

export const deleteMacTemplateLoginWindow = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/mac/loginwindows`);
}

export const addMacTemplateLoginWindow = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/mac/loginwindows`, params);
}

export const getMacTemplateLoginWindow = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/mac/loginwindows`);
}

export const deleteTemplateVpn = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/vpns`);
}

export const addTemplateVpn = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/vpns`, params);
}

export const getTemplateVpn = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/vpns`);
}

export const deleteTemplateMacWallpaper = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/mac/wallpapers`);
}

export const addTemplateMacWallpaper = (templateId: string, _params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key])
  }
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/mac/wallpapers`, params);
}

export const getTemplateMacWallpaper = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/mac/wallpapers`);
}


export const deleteTemplateMacDiskManagement = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/mac/diskManagements`);
}

export const addTemplateMacDiskManagement = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/mac/diskManagements`, params);
}

export const getTemplateMacDiskManagement = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/mac/diskManagements`);
}

export const deleteTemplateMacTimeMachine = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/mac/timeMachines`);
}

export const addTemplateMacTimeMachine = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/mac/timeMachines`, params);
}

export const getTemplateMacTimeMachine = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/mac/timeMachines`);
}

export const deleteTemplateAirPrint = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/airPrints`);
}

export const addTemplateAirPrint = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/airPrints`, params);
}

export const getTemplateAirPrint = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/airPrints`);
}

export const deleteTemplateEnergySaver = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/energySavers`);
}

export const addTemplateEnergySaver = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/energySavers`, params);
}

export const getTemplateEnergySaver = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/energySavers`);
}

export const deleteTemplateDock = (templateId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/ios/settings/templates/${templateId}/docks`);
}

export const addTemplateDock = (templateId: string, params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/ios/settings/templates/${templateId}/docks`, params);
}

export const getTemplateDock = (templateId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/ios/settings/templates/${templateId}/docks`);
}